/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Flex, Text } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';
import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';

import * as Board from 'solis/react/board';

import ColonyData from 'solis/react/board/data/colony';
import TransformData from 'solis/react/board/data/transform';

import { makeTransform } from 'solis/type/hex/transform';

import Args from 'solis/claude/action/args';

import useAttachPlacement from 'solis/claude/action/attach/placement';
import CreateAnchor from 'solis/claude/action/descriptor/create.anchor';
import ActionFooter from 'solis/claude/action/footer';


// Steps through the legal footprints covering the picked hex, snuggest fit first.
const OnPositionStep = (event, dispatch, count, position, delta) =>
{
  dispatch.replaceArgs({ [Args.AnchorPosition]: (position + delta + count) % count });
};


const OnAttached = (dispatch) =>
{
  dispatch.pushForeground({ route: Routes.Dashboard });
};


export default () =>
{
  const route = use(Route);

  const board = use(Galaxy).getBoard(route.getArg('id'));

  const dispatch = use(Navigation.Dispatch);

  const placement = useAttachPlacement(board);

  const count = placement.transforms ? placement.transforms.length : 0;

  const onPrevious = useCallback(OnPositionStep, [ dispatch, count, placement.position, -1 ]);
  const onNext = useCallback(OnPositionStep, [ dispatch, count, placement.position, 1 ]);

  const onAttached = useCallback(OnAttached, [ dispatch ]);

  const colonyData = new ColonyData({ colony: placement.sourceColony });
  const data = new TransformData({ data: colonyData, transform: makeTransform(null, placement.rotation) });

  const targetColony = placement.targetColony ? board.getColony(placement.targetColony) : null;

  const args = CreateAnchor.buildArgs({ board, sourceColony: placement.sourceColony, targetColony: placement.targetColony, transform: placement.transform });

  return (
    <Flex direction = 'column' gap = '4' p = '4'>

      <Text size = '2' weight = 'medium'>{placement.sourceColony.getName()}</Text>

      <Board.WithData data = {data} width = {280} height = {260} zoom = {1} settings = {Board.Preview} />

      <Flex gap = '4' align = 'center'>
        <Button variant = 'soft' onClick = {onPrevious} disabled = {count === 0} style = {{ flexGrow: 1 }}>⟨ Prev</Button>
        <Text size = '1' color = 'gray' style = {{ minWidth: '3rem', textAlign: 'center' }}>{count !== 0 ? (placement.position + 1) + ' / ' + count : '—'}</Text>
        <Button variant = 'soft' onClick = {onNext} disabled = {count === 0} style = {{ flexGrow: 1 }}>Next ⟩</Button>
      </Flex>

      <Text size = '1' color = 'gray'>{'Target: ' + (targetColony ? targetColony.getName() : '—')}</Text>

      <ActionFooter type = {CreateAnchor.type} args = {args} valid = {placement.valid} issues = {placement.issues} onSuccess = {onAttached} />

    </Flex>
  );
};
